export default {"src":"/_next/static/image/public/images/ic_off_box_left.bf0bcedc04994dd0ffffde60dac802b9.svg","height":23,"width":103};